import React from 'react';
import Galaxy from './Galaxy';
import GlassButton from './GlassButton';

function App() {
  return (
    <div style={{ 
      width: '100vw', 
      height: '100vh',
      backgroundColor: '#000000',
      position: 'relative'
    }}>
      <Galaxy 
        mouseRepulsion={true}
        mouseInteraction={true}
        density={1.5}
        glowIntensity={0.5}
        saturation={0.8}
        hueShift={240}
      />
      
      {/* Main Buttons Container */}
  <div style={{ 
    position: 'absolute', 
    top: '50%', 
    left: '50%', 
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '90%',
    maxWidth: '600px',
    padding: '20px',
    boxSizing: 'border-box',
    gap: '20px'
  }}>
    {/* Donation Button */}
    <GlassButton 
      className="donate"
      onClick={() => window.open('https://niabat.ansar-h.ir/', '_blank')}
      style={{ 
        width: '100%',
        padding: '20px',
        fontSize: '24px',
        fontWeight: 'bold',
        letterSpacing: '1px'
      }}
    >
      مشارکت مالی
    </GlassButton>
    
    {/* Social Media Buttons */}
    <GlassButton 
      className="instagram"
      onClick={() => window.open('https://www.instagram.com/ansarolhosain_ir', '_blank')}
      style={{
        width: '100%',
        padding: '18px',
        fontSize: '22px',
        letterSpacing: '1px'
      }}
    >
      اینستاگرام
    </GlassButton>
    
    <GlassButton 
      className="eitaa"
      onClick={() => window.open('https://eitaa.com/ansaroolhosain', '_blank')}
      style={{
        width: '100%',
        padding: '18px',
        fontSize: '22px',
        letterSpacing: '1px'
      }}
    >
      ایتا
    </GlassButton>
    
    <GlassButton 
      className="telegram"
      onClick={() => window.open('https://t.me/ansaroolhosain', '_blank')}
      style={{
        width: '100%',
        padding: '18px',
        fontSize: '22px',
        letterSpacing: '1px'
      }}
    >
      تلگرام
    </GlassButton>
    
</div>
    </div>
  );
}

export default App;